import { render } from "./RiverBasin.vue?vue&type=template&id=186c98a4&scoped=true"
import script from "./RiverBasin.vue?vue&type=script&lang=js"
export * from "./RiverBasin.vue?vue&type=script&lang=js"

import "./RiverBasin.vue?vue&type=style&index=0&id=186c98a4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-186c98a4"]])

export default __exports__